import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatService } from 'src/app/___LOGIC/__common/chat.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { ApiConnectorService } from 'src/app/___LOGIC/__api/api-connector.service';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { CrudFieldsDataService } from 'src/app/___LOGIC/__crud/crud-fields-data.service';

@Component({
  selector: 'app-client-interactions',
  templateUrl: './client-interactions.component.html',
  styleUrls: ['./client-interactions.component.css']
})
export class ClientInteractionsComponent implements OnInit {

  clientInteractions = [];
  clientId;
  selected;
  exportFlag;
  config1;

  constructor(private resolver: ResolverService,private router: Router,private chatService: ChatService,private route: ActivatedRoute,private apiConnector: ApiConnectorService,private commonFunctions: FunctionsService,private crudFieldsData: CrudFieldsDataService
  ) {
    /* this.resolver.getBackendDataForQueryId('getInteractionXclient',true,this.chatService.getSelectedClientConversation()); */
    this.clientId = this.route.snapshot.paramMap.get('id');
    this.getClientInteractions(this.clientId);
  }

  ngOnInit(): void {
  }

  getAllInteractions(){
    return this.clientInteractions;
  }

  async getClientInteractions(clientId){
    let url = 'https://dashboard.voyjaleas.com/api-dashboard/get/queryHandler.php?queryId=getInteractionXclient&queryParam1='+clientId;
    let data = await this.apiConnector.getXhr(url).toPromise();
    data && data['data']? this.clientInteractions = data['data'] : [];
  }

  getIcon(category){
    let iconData = {
      css: '',
      icon: ''
    }
    switch(category){
      case 'Communication':
        iconData.css = 'fas fa-comment-dots fs-18';
        break;
      default:
        iconData.css = 'icon f7-icons text-color-green';
        iconData.icon = 'ellipses_bubble_fill';
    }
    return iconData;
  }


  /* MIGRATED FROM THE OLD CODE */
  getUserVisibleInteractions(){
    let res = [];
    for(let interaction of this.clientInteractions){
      if(this.clientId){
        if(interaction.category && interaction.category != 'Calendar' && interaction.archived ==0){
          res.push(interaction);
        }
      }else{
        if(interaction.category && interaction.category === 'Calendar' && interaction.archived == 0){
          res.push(interaction);
        }
      }
    }
    return res;
  }

  isDateEmpty(date){
    return date === '0000-00-00';
  }

  completeInteraction(event,id){
    debugger
    let obj= {
      message: 'Confirm complete interaction?',
      button1: 'Ok'
    };

  /*     
  this.guiFLow.openDefaultConfirmationModal(obj);
    this.guiFLow.getDialogRef().afterClosed().subscribe(result => {
      if(result.confirmation){
        this.loading = true;
        this.apiConnector.simpleQueryId('completeInteraction',id,null,null,null,null).subscribe(response => this.saveData(response))
      }
      return result;
    }); */
  }

  archiveInteraction(id){
    let obj= {
      message: 'Confirm archive interaction?',
      button1: 'Ok'
    };
    /* this.guiFLow.openDefaultConfirmationModal(obj);
    this.guiFLow.getDialogRef().afterClosed().subscribe(result => {
      if(result.confirmation){
        this.loading = true;
        this.apiConnector.simpleQueryId('archiveInteraction',id,null,null,null,null).subscribe(response => this.saveData(response))
      }
      return result;
    }); */
  }

  openDetails(selected){
    this.selected = selected;
  }

  getFullName(i){
    return i.lastname + ','+i.name;
  }

  getCurrentObjFromForm(crudConfigObj){
    // Save last contact date to oclientFollowUp
    //this.getQuestionAnswers(this.currentClient);
    // PUT a client follow-up con el clientId = currentId
    this.apiConnector.simpleQueryId('lastInteractionDate',crudConfigObj.currentId,this.commonFunctions.getCurrentDate('yyyy/mm/dd'),null,null,null).subscribe(
      (response) => {
            console.log('updated lastInteractionDate')
          },
      (error) => {
          /* this.guiFlow.reportError(error,'mark email as read error'); */
          }
      );
  }

    initCrud(){
    // REFACTOR : ojo que las funciones de create dependen de quien elija en el FK_1 y en el FK_2 a uno le pone el currentId al otro el insertado FK
    this.config1= {
      id: this.config1 && this.config1.id? this.config1.id : this.commonFunctions.generateRandomNumber(),
      tableName: 'clientInteraction',
      cacheLabel: 'getInteractionXclient'+ this.commonFunctions.getSelectedClientId(),
      preloadedValues: [],
      tableProperties: [
        {
            "columnName": "id",
            "dataType": "int"
        },
        {
            "columnName": "comments",
            "dataType": "text"
        },
        {
            "columnName": "consult",
            "dataType": "text"
        },
        {
            "columnName": "action",
            "dataType": "text"
        },
        {
            "columnName": "suggestion",
            "dataType": "text"
        },
        {
            "columnName": "category",
            "dataType": "varchar"
        },
        {
            "columnName": "date",
            "dataType": "date"
        },
        {
            "columnName": "dueDate",
            "dataType": "date"
        },
        {
            "columnName": "archived",
            "dataType": "tinyint"
        },
        {
            "columnName": "completed",
            "dataType": "tinyint"
        },
        {
            "columnName": "FK_ID_clientDetails",
            "dataType": "int"
        },
        {
            "columnName": "FK_ID_clientInteraction",
            "dataType": "int"
        }
    ],
      table1: 'clientInteraction',
      table2: 'clientDetails',
      tableX: 'interactionXclient',
      FK_1: 'FK_ID_clientDetails',
      FK_2: 'FK_ID_clientInteraction',
      FK_1_value: null,
      FK_2_value: null,
      queryName: 'getInteractionXclient',
      hiddenInputFields: [
        'FK_ID_clientDetails',
        'FK_ID_clientInteraction',
      ],
      mandatoryFields: [
        'category'
      ],
      currentId: this.commonFunctions.getSelectedClientId(),
      showCreateUpdateButtons: true
    };
  }

}
